import { writable } from 'svelte/store'

/**
 * You can find the related content here: https://bucket3pod.my3pod.com/languages_contents/es.json
 * @typedef ContentsInterface
 * @type {Object}
 * @type {String} content
 * 
*/
let ContentsInterface;
let HostPublicBucket = "https://bucket3pod.my3pod.com";
if(window.location.host.search("3pod.io") >= 0 || window.IS_ONLINE === false){
    HostPublicBucket = "https://bucket.3pod.io";
}

/**
 * 
 * @param {String} language 
 * @returns 
 */
function valid_languages(language){
    const valids = ["es","en"];
    if(language === "pt"){
        return "es";
    }
    
    if(valids.includes(language)){
        return language;
    }

    return "en";
}

function contentsPlatformData() {
    const { subscribe, update, set } = writable({
        loaded: false,
        language: "es"
    });

    return {
        subscribe,
        update: update,
    };
}

const ContentsPlatformData = contentsPlatformData();


function altContents() {
    const { subscribe, update } = writable({
        current_lang: null,
        es: {},
        en: {}
    });

    return {
        subscribe,
        update,
    };
}

const AltContents = altContents();

function contents() {


    /**
     * @type {Record<string, ContentsInterface>}
     */
    let contents = {};

    const { subscribe, update, set } = writable(contents);

    return {
        subscribe,
        get: function(id, default_data){
            let contents = window?.ContentsAll ?? null;
            default_data  = default_data ?? null;
            try {
                return contents[id] ?? default_data;
            } catch (error) {
                return default_data;
            }
        },
        /**
         * 
         * @param {String} id 
         * @param {Boolean|String} _default - set as true to set as default the same id content
         * @returns 
         */
        get_content(id, _default = "Undefined Text")
        {
            let contents = window?.ContentsAll ?? {};
            let content = contents[id] ?? null;
            if(content === null){
                if(_default === true){
                    return id;
                }

                return _default
            }

            return content;

        },
        /**
         * same as get_content but with custom object contents
         * @param {String} id 
         * @param {Boolean|String} _default - set as true to set as default the same id content
         * @returns 
         */
        get_content_from(id, _default = "-", object = {})
        {
            let contents = object;
            let content = contents[id] ?? null;
            if(content === null){
                if(_default === true){
                    return id;
                }

                return _default
            }

            return content;

        },
        set: (data, language)=>{
            set(data);
            ContentsPlatformData.update((data)=>{
                data.loaded = true;
                data.language = language;
                return data;
            })
        },
        get_json: function(content){
            try {
                content = JSON.parse(content);
                return content;
            } catch (error) {
                console.error(error)
                return content
            }
        },
        set_content: function(string, variables){
            // Se crea una expresión regular que busca los patrones {{ variable }}
            let regex = /{{\s*(\w+)\s*}}/g;
            // Se devuelve el string con las variables reemplazadas por sus valores
            return string.replace(regex, (match, key) => {
                // Se verifica si la variable existe en el objeto
                if (key in variables) {
                    // Se devuelve el valor de la variable
                    return variables[key];
                } else {
                    // Se devuelve el mismo patrón sin reemplazar
                    return match;
                }
            });
        },
        /**
         * get content id and set variables.
         * @param {String} id id on ContentsAll
         * @param {Object} variables - field name and value that will replace the variable string.
         */
        set_from_id: function(id, variables = {}, _default = "", source_lang)
        {
            source_lang = source_lang ?? window.lang_selected ?? "es";

            let contents = window?.ContentsAll ?? window?.AltContents[source_lang] ?? {};
            let content = this.get_content_from(id, _default, contents) ?? "";
            return this.set_content(content, variables)
        },
        search: function(search_content, target_lang = null, variables = null, source_lang = "es"){
            variables = variables ?? {};
            let app = this;
            if((window?.ContentsAll ?? null) === null){
                return this.set_content(search_content, variables);
            }

            if(search_content.startsWith("ctn_")){
                return this.set_from_id(search_content, variables, search_content);
            }

            if(target_lang === null){
                if((window?.user?.lang ?? null) !== null){
                    target_lang = user.lang;
                }else{
                    target_lang = window?.language ?? "es";
                }
            }
            
            

            let contents = window?.AltContents[source_lang] ?? [];
            let contents_target = window?.AltContents[target_lang] ?? [];
            let found = null;
            

            if(target_lang === "es"){
                return this.set_content(search_content, variables);
            }
            
            let map = Object.values(contents);
            let map_target = Object.values(contents_target);
            for (let index = 0; index < map.length; index++) {
                const content = map[index];
                if(search_content.toLowerCase() === content.toLowerCase()){
                    const content_target = map_target[index];
                    found = content_target;
                }
                if(found !== null){break;}
            }

            if(found === null){
                return this.set_content(search_content, variables);
            }
            
            return this.set_content(found, variables);
        },
        set_content_already_load: function(language){
            window.already_load_lang = window?.already_load_lang ?? {}; 
            window.already_load_lang[language] = true;
        },
        get_content_already_load: function(language){
            window.already_load_lang = window?.already_load_lang ?? {}; 
            try {
                if(window?.already_load_lang[language]){
                    return true;
                }
            } catch (error) {
                
            }

            return false;
        },
        load_both: function(lang_selected, callback){
            callback = callback || function(){};
            Contents.set_language(lang_selected, false, ()=>{
                let next = "en";
                if(lang_selected === "en"){
                    next = "es";
                }  
                Contents.get_alternative(next, ()=>{
                    callback();
                })                        
            })
        },
        get_alternative: function(language, on_load){
            language = valid_languages(language);

            let date_version = window.IS_ONLINE ? "none" : `${new Date().getTime()}`
            let app = this;
            let version = `?build_version=${window.build_version}&date_version=${date_version}`;
            let urlHelper = `https://app.3pod.io/default/public/assets/language/${language}.json${version}`
            let url = `${HostPublicBucket}/languages_contents/${language}.json${version}`;

            
            function on_ready(data){
                AltContents.update((current_data)=>{
                    current_data[language] = data;
                    window.AltContents = current_data; 
                    return current_data;
                });
                on_load(data, language);
                app.set_content_already_load(language)
            }

            fetch(url)
            .then(response => response.json())
            .then(data => {
                on_ready(data)
            }).catch(function(){
                fetch(urlHelper)
                .then(response => response.json())
                .then(data => {
                    on_ready(data)
                })
            })
        },
        set_language: function(language, local, on_load) {
            let app = this;
            

            language = language ?? "es";
            language = valid_languages(language);
            on_load = on_load || function(){}
            local = local ?? false;
            let date_version = window.IS_ONLINE ? "none" : `${new Date().getTime()}`;

            let version = `?build_version=${window.build_version}&date_version=${date_version}`
            let urlHelper = `https://app.3pod.io/default/public/assets/language/${language}.json${version}`
            let url = `${HostPublicBucket}/languages_contents/${language}.json${version}`;

            if(local === true){
                url = `${window.assets}/language/${language}.json`;
            }

            function on_ready(data){
                app.set(data, language);

                AltContents.update((current_data)=>{
                    current_data[language] = data;
                    current_data.current_lang = language;
                    window.AltContents = current_data; 
                    return current_data;
                });
                app.set_content_already_load(language)
                on_load();
            }
            
            fetch(url)
            .then(response => response.json())
            .then(data => {
                on_ready(data)
            }).catch(function(){
                fetch(urlHelper)
                .then(response => response.json())
                .then(data => {
                    on_ready(data)
                })
            })
             
        }
    };
}



const Contents = contents();


export {
    Contents,
    AltContents,
    ContentsPlatformData
}